import classNames from 'classnames/bind'
import { ReactNode } from 'react'

import styles from './snippet-carousel-item.module.scss'

const cx = classNames.bind(styles)

export interface SnippetCarouselItemProps {
  children: ReactNode
  className?: string
}

export function SnippetCarouselItem(props: SnippetCarouselItemProps) {
  const { children, className } = props
  return <div className={cx('SnippetCarouselItem', className)}>{children}</div>
}
